import { useCurrentUser } from '@cosuno/authentication-frontend';
import { Button, Icon } from '@cosuno/cosuno-ui';
import { Modal, MODAL_VARIANTS, useModalState } from '@cosuno/modal-frontend';
import { useQueryParamBoolean } from '@cosuno/react-router';

import { LANGUAGE } from '~/__gql__/graphql';
import { openNavatticModal } from '~/packages/navattic';
import { useUiState } from '~/shared/contexts/uiStateContext';
import useAnalytics from '~/shared/hooks/useAnalytics';
import useTranslation from '~/shared/hooks/useTranslation';

import illustrationUrlDE from './IllustrationDE.svg';
import illustrationUrlEN from './IllustrationEN.svg';
import { Explanation, GetStartedButton, Illustration, Title, Wrapper } from './Styles';

const demoUrl = 'https://capture.navattic.com/cm1fgciw3000203ldg0vq6ids';

const GetStarted: React.FC = () => {
  const { i18n, t } = useTranslation('getStarted');
  const user = useCurrentUser();
  const { trackEvent } = useAnalytics();

  const modalState = useModalState({
    onClose: (closeReason) => {
      if (closeReason === 'close-button' || closeReason === 'esc-key') {
        trackEvent('onboardingTourPopupClose');
      }
    },
  });

  const { isMainNavigationCollapsed } = useUiState();

  useQueryParamBoolean('showNavatticModal', (value) => {
    if (value) {
      modalState.openModal();
      trackEvent('onboardingTourPopupImpression');
    }
  });

  if (!user?.isNavatticEnabled) {
    return null;
  }

  return (
    <>
      <Modal
        {...modalState}
        variant={MODAL_VARIANTS.promotional}
        allowOverflow
        renderContent={() => (
          <Wrapper>
            <Illustration
              src={i18n.language === LANGUAGE.de ? illustrationUrlDE : illustrationUrlEN}
              alt=""
            />
            <Title>{t('modalTitle')}</Title>
            <Explanation>{t('modalDescription')}</Explanation>
            <Button
              variant="primaryInverted"
              size="large"
              onClick={() => {
                openNavatticModal({
                  demoUrl,
                  title: t('navatticPopupTitle'),
                  onOpen: modalState.closeModal,
                });
                trackEvent('onboardingTourStart');
              }}
            >
              {t('modalButton')}
            </Button>
          </Wrapper>
        )}
      />
      <GetStartedButton
        onClick={() => {
          modalState.openModal();
          trackEvent('onboardingTourPopupOpen');
        }}
        $isMainNavigationCollapsed={isMainNavigationCollapsed}
      >
        <Icon type="rocket-launch" size={24} />
        {t('buttonLabel')}
      </GetStartedButton>
    </>
  );
};

export default GetStarted;
